import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Avstralci in mucke",
  "description": "",
  "published": "2007-05-09T00:00:00.000Z",
  "redirect_from": ["/blog/avstralci-in-mucke/swizec/216"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Tole je video avstralke, ki bere pravljico, ne vem zakaj, ampak zdi se mi neverjetno smešno.`}</p>
    <p>{`Tole pa je uprizoritev obsesivno-kompulzivno ciste osebe.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      